<template>
    <router-link v-if="event" :to="event.url" target="_self" class="schedule-item">
        <div class="schedule__image">
            <img v-if="event.image" :src="utils.image(event.image, 169, 152)" alt="">
            <div class="schedule-date">
                <span>{{new Date(event.start_date.replace(/-/g, '/')).getDate()}}</span>
                <span>{{utils.months[new Date(event.start_date.replace(/-/g, '/')).getMonth()]}}</span>
            </div>
        </div>
        <div class="schedule__infos">
            <div class="schedule__title">
                <p>{{event.title}}</p>
            </div>
            <div class="schedule__location">
                <p>
                    {{event.start_time.substring(0,5)}} - 
                    {{event.end_time.substring(0,5)}}
                </p>
                <p>{{event.address}}</p>
                
            </div>
            <div class="schedule__btn-action">
                <p>Saiba mais</p>
            </div>
        </div>
    </router-link>
</template>

<script>
import utils from '@/utils'

export default {
    name:'Related',
    props:['event'],
    data: function() {
        return {
            utils:utils,
        }
    }
}
</script>